var _defs, _rect, _g, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHubImagesWeb5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#805eb5;}.cls-2,.cls-7{opacity:0.75;}.cls-3{opacity:0.3;}.cls-4{fill:#dd67ff;}.cls-5{fill:#b754ea;}.cls-6{fill:#d77af9;}.cls-7{fill:none;stroke:#fff;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-8{opacity:0.5;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 900,
    height: 450
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "684.77 133.88 647.04 155.66 609.3 133.88 647.04 112.09 684.77 133.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647,199.25V155.67L609.3,133.88v41.26a4,4,0,0,0,2,3.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.78,133.88,647,155.67v43.58l35.19-20.32a5.12,5.12,0,0,0,2.55-4.41Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "687.37 122.64 647.04 145.93 606.7 122.64 647.04 99.34 687.37 122.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "647.04 192.51 647.04 145.93 606.7 122.64 606.7 169.22 647.04 192.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "687.37 122.64 647.04 145.93 647.04 192.51 687.37 169.22 687.37 122.64"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 627.34,
    y1: 157.91,
    x2: 547.69,
    y2: 203.36
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 666.92,
    y1: 157.91,
    x2: 746.57,
    y2: 203.36
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "553.68 209.64 515.95 231.43 478.21 209.64 515.95 187.85 553.68 209.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516,275V231.43l-37.74-21.79v41.59a3.42,3.42,0,0,0,1.72,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.68,209.64,516,231.43V275l35.79-20.67a3.88,3.88,0,0,0,1.94-3.36Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "556.28 198.4 515.95 221.69 475.61 198.4 515.95 175.11 556.28 198.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "515.95 268.27 515.95 221.69 475.61 198.4 475.61 244.98 515.95 268.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "556.28 198.4 515.95 221.69 515.95 268.27 556.28 244.98 556.28 198.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "815.86 209.64 778.12 231.43 740.38 209.64 778.12 187.85 815.86 209.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M778.12,275V231.43l-37.74-21.79V250.2a5.24,5.24,0,0,0,2.62,4.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M815.86,209.64l-37.74,21.79V275l35.54-20.52a4.41,4.41,0,0,0,2.2-3.81Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "818.46 198.4 778.12 221.69 737.78 198.4 778.12 175.11 818.46 198.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "778.12 268.27 778.12 221.69 737.78 198.4 737.78 244.98 778.12 268.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "818.46 198.4 778.12 221.69 778.12 268.27 818.46 244.98 818.46 198.4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 536.94,
    y1: 234.08,
    x2: 616.59,
    y2: 279.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 757.54,
    y1: 233.4,
    x2: 677.89,
    y2: 278.85
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "684.77 285.29 647.04 307.07 609.3 285.29 647.04 263.5 684.77 285.29"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647,350.65V307.07L609.3,285.29v40.25a5.77,5.77,0,0,0,2.88,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.78,285.29,647,307.07v43.58l35.05-20.24a5.36,5.36,0,0,0,2.69-4.64Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "687.37 274.05 647.04 297.34 606.7 274.05 647.04 250.75 687.37 274.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "647.04 343.92 647.04 297.34 606.7 274.05 606.7 320.63 647.04 343.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "687.37 274.05 647.04 297.34 647.04 343.92 687.37 320.63 687.37 274.05"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: -128.3,
    y: -22.74,
    width: 1157.5,
    height: 513.81,
    rx: 40.66
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubImagesWeb5);
export default __webpack_public_path__ + "static/media/HubImagesWeb5.78ec8da7b0a0b61bf8f68c6b431e0925.svg";
export { ForwardRef as ReactComponent };